import axios from "axios";
import _ from "lodash";
import { getAuth, getIdToken } from "firebase/auth";


const UseApiManager = () => {

    const getToken = async (refresh = false) => {
        return await getAuth().currentUser?.getIdToken()
    }

    const Req = async (method, path, options) => {
        let url = `${process.env.REACT_APP_API_ENDPOINT}/${path}`
        const token = await getToken()
        options = {
            ...options,
            params: { ...options?.params },
            headers: { ...options?.headers, Authorization: `Bearer ${await getToken()}` }
        }
        console.log("[Api]", "request", url, options)

        const res = await axios({
            method,
            url,
            ...options,
        })
        if (_.isNil(res?.data?.result) || _.isNil(res?.data.rows)) {
            console.log('[Api]', 'failed response empty', res?.data)
            throw new Error('Invalid response')
        }
        if (!res.data.result) {
            console.log('[API]', 'error response', res.data)
            throw new Error('Response error')
        }
        return res.data.rows
    }

    const Get = (path, params, options) =>
        Req("get", path, { ...options, params })

    const Post = (path, data, options) =>
        Req("post", path, { ...options, data })

    const Put = (path, data, options) =>
        Req("put", path, { ...options, data })

    const Delete = (path, data, options) =>
        Req("delete", path, { ...options, data })

    const GetFirst = async (path, params, options) =>
        _.first(await Get(path, params, options))

    const PostFirst = async (path, data, options) =>
        _.first(await Post(path, data, options))

    const PutFirst = async (path, data, options) =>
        _.first(await Put(path, data, options))

    const DeleteFirst = async (path, data, options) =>
        _.first(await Delete(path, data, options))

    const GetOne = async (path, params, options) => {
        const row = await GetFirst(path, params, options)
        if (_.isEmpty(row)) { return null }
        return row[_.first(Object.keys(row))]
    }

    const PostOne = async (path, data, options) => {
        const row = await PostFirst(path, data, options)
        if (_.isEmpty(row)) { return null }
        return row[_.first(Object.keys(row))]
    }

    const PutOne = async (path, data, options) => {
        const row = await PutFirst(path, data, options)
        if (_.isEmpty(row)) { return null }
        return row[_.first(Object.keys(row))]
    }

    const DeleteOne = async (path, data, options) => {
        const row = await DeleteFirst(path, data, options)
        if (_.isEmpty(row)) { return null }
        return row[_.first(Object.keys(row))]
    }


    return {
        getToken,
        Req,
        Get, GetFirst, GetOne,
        Post, PostFirst, PostOne,
        Put, PutFirst, PutOne,
        Delete, DeleteFirst, DeleteOne,
    }

}

export default UseApiManager
